import React from 'react';
import LoadingButton from '@mui/lab/LoadingButton';
import ArchiveIcon from '@mui/icons-material/ArchiveOutlined';

import { useLeadsPageContext } from 'src/pages/landlord/leads/provider';
import { Flex } from 'src/components/flex';

export default function ArchivedLeadsStatus() {
    const { showArchived, setShowArchived, isLoadingArchivedLeads } = useLeadsPageContext();

    return (
        <Flex width="100%" p={2} justifyContent="center" alignItems="center">
            <LoadingButton
                variant="contained"
                onClick={() => {
                    setShowArchived(prev => !prev);
                }}
                loading={isLoadingArchivedLeads}
                loadingPosition="start"
                startIcon={<ArchiveIcon />}
                data-testid="show-archived-toggle"
            >
                {showArchived ? 'Hide' : 'Show'} archived leads
            </LoadingButton>
        </Flex>
    );
}
